module.exports = __webpack_public_path__ + "img/03.61b73a58.png";